import ArrowUpIcon from './components/ArrowUpIcon';
import BusinessIcon from './components/BusinessIcon';
import CalendarIcon from './components/CalendarIcon';
import CaretIcon from './components/CaretIcon';
import TickIcon from './components/TickIcon';
import DashboardIcon from './components/DashboardIcon';
import DocsIcon from './components/DocsIcon';
import EyeCrossedIcon from './components/EyeCrossedIcon';
import EyeIcon from './components/EyeIcon';
import FactiveIcon from './components/FactiveIcon';
import FactiveTextIcon from './components/FactiveIconTextIcon';
import FilledCaretDownIcon from './components/FilledCaretDownIcon';
import FilledCaretUpIcon from './components/FilledCaretUpIcon';
import LockIcon from './components/LockIcon';
import MoonIcon from './components/MoonIcon';
import SunIcon from './components/SunIcon';
import TagIcon from './components/TagIcon';
import UserIcon from './components/UserIcon';
import UsersIcon from './components/UsersIcon';
import CrossIcon from './components/CrossIcon';
import CopyIcon from './components/CopyIcon';
import UnclustIcon from './components/UnclustIcon';
import SearchIcon from './components/SearchIcon';
import TwoDotsIcon from './components/TwoDotsIcon';
import SortArrowTopIcon from './components/SortArrowTopIcon';
import CardsViewIcon from './components/CardsViewIcon';
import TableViewIcon from './components/TableViewIcon';
import ResonanceIcon from './components/ResonanceIcon';
import SonarIcon from './components/SonarIcon';
import CirclePlusIcon from './components/CirclePlusIcon';
import CircleMinusIcon from './components/CircleMinusIcon';
import LikeIcon from './components/LikeIcon';
import InfoIcon from './components/InfoIcon';
import EditIcon from './components/EditIcon';
import DeleteIcon from './components/DeleteIcon';
import ScoutIcon from './components/ScoutIcon';
import DropperIcon from './components/DropperIcon';
import DonutIcon from './components/DonutIcon';
import BoldIcon from './components/BoldIcon';
import ItalicIcon from './components/ItalicIcon';
import UnderlineIcon from './components/UnderlineIcon';
import TIcon from './components/TIcon';
import AlignJustifyIcon from './components/AlignJustifyIcon';
import AlignLeftIcon from './components/AlignLeftIcon';
import AlignCenterIcon from './components/AlignCenterIcon';
import AlignRightIcon from './components/AlignRightIcon';
import UndoIcon from './components/UndoIcon';
import RedoIcon from './components/RedoIcon';
import ImageIcon from './components/ImageIcon';
import EmojiIcon from './components/EmojiIcon';
import ListNumberedIcon from './components/ListNumberedIcon';
import ListDottedIcon from './components/ListDottedIcon';
import ShareIcon from './components/ShareIcon';
import SettingsIcon from './components/SettingsIcon';
import SaveFileIcon from './components/SaveFileIcon';
import ReloadIcon from './components/ReloadIcon';
import PulseIcon from './components/PulseIcon';
import ImportIcon from './components/ImageIcon';
import ScanIcon from './components/ScanIcon';
import ReturnIcon from './components/ReturnIcon';
import NoCompanyLogoIcon from './components/NoCompanyLogoIcon';
import FacebookIcon from './components/FacebookIcon';
import TrustpillotIcon from './components/TrustpillotIcon';
import TwitterIcon from './components/TwitterIcon';
import TikTokIcon from './components/TikTokIcon';
import LinkedInIcon from './components/LinkedInIcon';
import InstagramIcon from './components/InstagramIcon';
import YouTubeLogoIcon from './components/YouTubeLogoIcon';
import PointerToTheRightIcon from './components/PointerToTheRightIcon';
import ResetIcon from './components/ResetIcon';
import AimIcon from './components/AimIcon';
import CleanIcon from './components/CleanIcon';
import ImportIcon2 from './components/ImportIcon';
import FileIcon from './components/FileIcon';
import EmailIcon from './components/EmailIcon';
import AiPlaygroundIcon from './components/AiPlaygroundIcon';
import GenieIcon from './components/GenieIcon';
import RoundArrowIcon from './components/RoundArrowIcon';
import Activ8Icon from './components/Activ8Icon';
import YouTubeShortLogo from './components/YouTubeShortLogo';
import SnapchatLogo from './components/SnapchatLogo';
import MetaLogo from './components/MetaLogo';

export const ICONS = {
  Sun: SunIcon,
  Moon: MoonIcon,
  Tag: TagIcon,
  Business: BusinessIcon,
  Docs: DocsIcon,
  Users: UsersIcon,
  Dashboard: DashboardIcon,
  Calendar: CalendarIcon,
  Logo: FactiveIcon,
  Factive: FactiveTextIcon,
  CaretUp: CaretIcon,
  Eye: EyeIcon,
  EyeCrossed: EyeCrossedIcon,
  ArrowUp: ArrowUpIcon,
  FilledCaretUp: FilledCaretUpIcon,
  FilledCaretDown: FilledCaretDownIcon,
  User: UserIcon,
  Lock: LockIcon,
  Tick: TickIcon,
  Cross: CrossIcon,
  Copy: CopyIcon,
  Unclust: UnclustIcon,
  Search: SearchIcon,
  TwoDots: TwoDotsIcon,
  SortArrowTop: SortArrowTopIcon,
  CardsView: CardsViewIcon,
  TableView: TableViewIcon,
  Resonance: ResonanceIcon,
  Sonar: SonarIcon,
  CirclePlus: CirclePlusIcon,
  CircleMinus: CircleMinusIcon,
  Like: LikeIcon,
  Info: InfoIcon,
  Edit: EditIcon,
  Delete: DeleteIcon,
  Scout: ScoutIcon,
  Dropper: DropperIcon,
  Donut: DonutIcon,
  Bold: BoldIcon,
  Italic: ItalicIcon,
  Underline: UnderlineIcon,
  T: TIcon,
  AlignJustify: AlignJustifyIcon,
  AlignLeft: AlignLeftIcon,
  AlignCenter: AlignCenterIcon,
  AlignRight: AlignRightIcon,
  Undo: UndoIcon,
  Redo: RedoIcon,
  Image: ImageIcon,
  Emoji: EmojiIcon,
  ListNumbered: ListNumberedIcon,
  ListDotted: ListDottedIcon,
  Share: ShareIcon,
  Settings: SettingsIcon,
  SaveFile: SaveFileIcon,
  Reload: ReloadIcon,
  Pulse: PulseIcon,
  Import: ImportIcon,
  Scan: ScanIcon,
  Return: ReturnIcon,
  NoCompanyLogo: NoCompanyLogoIcon,
  FacebookLogo: FacebookIcon,
  TrustpillotLogo: TrustpillotIcon,
  TwitterLogo: TwitterIcon,
  TikTokLogo: TikTokIcon,
  LinkedInLogo: LinkedInIcon,
  InstagramLogo: InstagramIcon,
  YouTubeLogo: YouTubeLogoIcon,
  PointerToTheRight: PointerToTheRightIcon,
  Reset: ResetIcon,
  Aim: AimIcon,
  Clean: CleanIcon,
  ImportIcon: ImportIcon2,
  File: FileIcon,
  Email: EmailIcon,
  AiPlayground: AiPlaygroundIcon,
  Genie: GenieIcon,
  RoundArrow: RoundArrowIcon,
  Activ8: Activ8Icon,
  YouTubeShortLogo: YouTubeShortLogo,
  SnapchatLogo: SnapchatLogo,
  MetaLogo: MetaLogo,
};
